var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuthors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 15,
    viewBox: "0 0 21 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.3501 15C9.3501 15 8.1001 15 8.1001 13.75C8.1001 12.5 9.3501 8.75 14.3501 8.75C19.3501 8.75 20.6001 12.5 20.6001 13.75C20.6001 15 19.3501 15 19.3501 15H9.3501ZM14.3501 7.5C15.3447 7.5 16.2985 7.10491 17.0017 6.40165C17.705 5.69839 18.1001 4.74456 18.1001 3.75C18.1001 2.75544 17.705 1.80161 17.0017 1.09835C16.2985 0.395088 15.3447 0 14.3501 0C13.3555 0 12.4017 0.395088 11.6984 1.09835C10.9952 1.80161 10.6001 2.75544 10.6001 3.75C10.6001 4.74456 10.9952 5.69839 11.6984 6.40165C12.4017 7.10491 13.3555 7.5 14.3501 7.5ZM7.1201 15C6.93479 14.6098 6.84238 14.1819 6.8501 13.75C6.8501 12.0563 7.7001 10.3125 9.2701 9.1C8.48646 8.85855 7.67003 8.74047 6.8501 8.75C1.8501 8.75 0.600098 12.5 0.600098 13.75C0.600098 15 1.8501 15 1.8501 15H7.1201ZM8.43481 6.58469C7.84876 7.17074 7.0539 7.49998 6.2251 7.49998C5.3963 7.49998 4.60144 7.17074 4.01539 6.58469C3.42934 5.99864 3.1001 5.20378 3.1001 4.37498C3.1001 3.54618 3.42934 2.75132 4.01539 2.16527C4.60144 1.57922 5.3963 1.24998 6.2251 1.24998C7.0539 1.24998 7.84876 1.57922 8.43481 2.16527C9.02086 2.75132 9.3501 3.54618 9.3501 4.37498C9.3501 5.20378 9.02086 5.99864 8.43481 6.58469Z",
    fill: "#6F7494"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthors);
export default __webpack_public_path__ + "static/media/Authors.6e597c5764eff805661917995dc845bc.svg";
export { ForwardRef as ReactComponent };